module.exports = __webpack_public_path__ + "static/header-4ebb610adeb91fb9af7fcb400ceea2fa.jpg";